import React from 'react'
import "./Loading.scss"
function Loading() {
  return (
    <div className="loading-spinner">
         <div className="bouncing-ball"></div>
    </div>
  )
}

export default Loading